export const STUDIES_TEAM_EMAIL = "etudes@capitole-finance.fr";
export const TEMPLATE_NOTIF_SM = "TEMPLATE_Notif_SM";

export const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const formatEmailBodyForTemplate = (text: string): string => {
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

  const withEntities = escaped.replace(/[^\x00-\x7F\n\r\t]/g, (char) =>
    `&#${char.charCodeAt(0)};`
  );

  return withEntities
    .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
    .replace(/\r\n|\n|\r/g, "<br/>");
};

export const parseJsonField = (value: unknown) => {
  if (!value) return null;
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
  return value;
};

export const getAgencyEmailFromOffer = (offer: any): string | null => {
  const businessData = parseJsonField(offer?.businessData);
  const additionalData = parseJsonField(businessData?.additionalData);
  const email = additionalData?.email ?? additionalData?.mail;
  if (typeof email === "string") {
    const trimmed = email.trim();
    if (trimmed && isValidEmail(trimmed)) {
      return trimmed;
    }
  }
  return null;
};

export const syncCcWithRecipients = (
  ccEmailsList: string[],
  selectedRecipients: string[],
  otherEmailsList: string[]
): string[] => {
  const recipientSet = new Set(
    [...selectedRecipients, ...otherEmailsList].map((email) => email.toLowerCase())
  );
  return ccEmailsList.filter((email) => !recipientSet.has(email.toLowerCase()));
};

export const getAllRecipientEmails = (
  selectedRecipients: string[],
  otherEmailsList: string[]
): string[] => {
  const emails: string[] = [...selectedRecipients];
  otherEmailsList.forEach((email) => {
    if (isValidEmail(email)) {
      emails.push(email);
    }
  });
  return [...new Set(emails)];
};
